const clearInput = (elementId: string) => {
  const railCarWayBillElement = document.getElementById(elementId) as unknown as HTMLInputElement
  if (railCarWayBillElement) {
    const clearInputButton = railCarWayBillElement.nextElementSibling
      ?.firstElementChild as HTMLElement
    clearInputButton.click()
  }
}

export default clearInput
